import React from "react";
import {Dialog} from "primereact/dialog";
import LinearProgress from "@material-ui/core/LinearProgress";

const NotificationMessagesView = ({...props}) => {
    return (
        <div>
            {props.messagesGrowl}
            <Dialog visible={props.visibleNotification} header={"Notificaciones"} modal={true}
                    closable={true} onHide={props.onHide}
                    style={{width: "45%",}}>
                <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
                <div style={{padding: "1.5em"}}>
                    {props.notificationTemplate}
                </div>
            </Dialog>
        </div>
    )
};

export default NotificationMessagesView;